import { Location } from '@angular/common';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { APP_ROUTING_NAMES } from 'src/app/app.routes.names';
import { AnsokanFormBuilderService } from 'src/app/service/ansokan-form-builder/ansokan-form-builder.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'app-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {

  @ViewChild(ModalComponent) public modal: ModalComponent;

  constructor(
    private location: Location,
    private authService: AuthService,
    private fb: AnsokanFormBuilderService,
    private zone: NgZone,
  ) { }

  public get authorized(): boolean {
    return Boolean(this.authService.getToken());
  }

  public ngOnInit() {
  }

  public logout(): void {
    this.fb.clearStorage();
    this.authService.logout()
      .subscribe(() => {
        this.location.go(APP_ROUTING_NAMES.START);
        this.zone.runOutsideAngular(() => location.reload());
      });
    this.authService.clearToken();
  }
}
